import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { OrganisationsPage } from "~/pages/settings/organisations/organisations-page";

export const Route = createFileRoute("/_app/settings/organisations/")({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.organisations") }],
  }),
  component: OrganisationsPage,
});
